


























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Description extends Vue {
  @Prop() private currentStep!: number;
  @Prop() private stepsTotal!: number;

  get isFinalStep() {
    return this.currentStep === 0 && this.stepsTotal === 0;
  }

  get customVuexStyles() {
    return {
      "--font-main": this.$store.state.globalCss.font.fontName,
      "--progress-bar-color": this.$store.state.globalCss.colors.progressBar
        .color,
      "--progress-bar-background-color": this.$store.state.globalCss.colors
        .progressBar.backgroundColor,
      "--progress-bar-label-color": this.$store.state.globalCss.colors
        .progressBar.labelColor
    };
  }
}
